import { useState } from 'react';
import './ShowEditFields.css';
import FloatingLoading from '../../PopUpModal/ModalVersions/FloatingLoading/FloatingLoading';
import { useYTUrl, useImagesLoading, useShowPopUpModal, useModalVersion, useModalInfo, useSelectedTitle, useSelectedDescription, useAwaitOffer, useLoggedUser, useSelectedImages, useUploadProgress, useShowLoadingAnim  } from '../../../data/GlobalStates';
import ImagesPreviewer from '../ImagesUploader/ImagesPreviewer';
import dataBase from '../../../config';
import { ref as AddOfferRef, set, get, child, increment } from "firebase/database";
import { ref, getDownloadURL, uploadBytesResumable, deleteObject, listAll , getStorage } from "firebase/storage";
import { useHistory } from 'react-router-dom';
import { useAtom } from 'jotai';
import { getAuth } from "firebase/auth";

const ShowEditFields = ({ refresh, setRefresh }) => {


        const history = useHistory();
        const db = dataBase; // zapis
        const dbRef = AddOfferRef(dataBase);// DO ODCZYTU
        const authedUser = getAuth(); 

        const date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate(); 



  //stany lokalne:
  const [ addressInfo, setAddressInfo] = useState('')


  //stany globalne:
  const [ LoggedUser, setLoggedUser ] = useAtom(useLoggedUser);
  const [ ShowPopUpModal, setShowPopUpModal ] = useAtom(useShowPopUpModal);
  const [ ModalVersion, setModalVersion ] = useAtom(useModalVersion);
  const [ ModalInfo, setModalInfo ] = useAtom(useModalInfo);
  const [ AwaitOffer, setAwaitOffer ] = useAtom(useAwaitOffer);
  const [ ImagesLoading, setImagesLoading ] = useAtom(useImagesLoading);
  const [ SelectedDescription, setSelectedDescription ] = useAtom(useSelectedDescription);
  const [ SelectedTitle, setSelectedTitle ] = useAtom(useSelectedTitle);
  const [ YTUrl, setYTUrl ] = useAtom(useYTUrl);
  const [ ShowLoadingAnim, setShowLoadingAnim ] = useAtom(useShowLoadingAnim);
  const [ SelectedImages, setSelectedImages ] = useAtom(useSelectedImages);
  const [ UploadProgress, setUploadProgress ] = useAtom(useUploadProgress);
   

const uploadImages = async (
  OfferID,
  SelectedImages,
  setSelectedImages,
  setImagesLoading,
  setUploadProgress
) => {
  setImagesLoading(true);
  const storage = getStorage();
  const folderRef = ref(storage, `OffersImages/${OfferID}`);
  const updatedImages = Array.isArray(SelectedImages) ? [...SelectedImages] : [];

  try {
    // Sprawdzanie istniejących plików
    let existingFiles = { items: [] };
    try {
      existingFiles = await listAll(folderRef);
    } catch (e) { console.log("Brak folderu lub błąd listAll"); }

    const toUpload = updatedImages.filter(img => img.file && !img.uploadedUrl);
    const totalFiles = toUpload.length;
    let completedFiles = 0;

    if (totalFiles > 0) {
      const uploadPromises = updatedImages.map(async (img, index) => {
        if (img.uploadedUrl?.startsWith("https://") || !img.file) return;

        const fileExt = img.file.name.split(".").pop();
        const uniqueName = `img-${Date.now()}-${index}.${fileExt}`;
        const fileRef = ref(storage, `OffersImages/${OfferID}/${uniqueName}`);

        return new Promise((resolve, reject) => {
          const uploadTask = uploadBytesResumable(fileRef, img.file, { contentType: img.file.type });

          uploadTask.on("state_changed", 
            (snapshot) => { /* progres */ },
            (error) => reject(error),
            async () => {
              const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
              updatedImages[index].uploadedUrl = downloadURL;
              completedFiles++;
              setUploadProgress(Math.round((completedFiles / totalFiles) * 100));
              resolve();
            }
          );
        });
      });
      await Promise.all(uploadPromises);
    }

    // Czyszczenie starego storage (opcjonalnie)
    // ... twój kod listAll i deleteObject ...

    setSelectedImages(updatedImages);
    return updatedImages; // KLUCZOWE: Zawsze zwraca tablicę

  } catch (error) {
    console.error("❌ Błąd synchronizacji:", error);
    return updatedImages; // Zwróć to co masz, nawet przy błędzie
  } finally {
    setImagesLoading(false);
    setUploadProgress('');
  }
};


  const showTitleInfo = () => {
    if (SelectedTitle.length && SelectedTitle.length < 66) {
      return (
        <div id='TitleLengthInfo'>
          <p>pozostało {65 - SelectedTitle.length} znaków</p>
        </div>
      )
    }
  };

  const saveTitle = (e) => {
    if (history.location.pathname === '/EdycjaOgloszenia') {
      if (e.target.value.length < 66) {
        setAwaitOffer({ ...AwaitOffer, title: e.target.value })
      } else if (e.target.value.length > 65) {
        setShowPopUpModal(true)
        setModalVersion(13)
        setModalInfo({ title: 'Tytuł może mieć max 65 znaków' })
        window.scrollTo(0, 0)
        setAwaitOffer({ ...AwaitOffer, title: e.target.value.slice(0, 65) })
      }
    } else if (history.location.pathname === '/DodajNews') {
      if (e.target.value.length < 66) {
        setSelectedTitle(e.target.value)
      } else if (e.target.value.length > 65) {
        setShowPopUpModal(true)
        setModalVersion(13)
        setModalInfo({ title: 'Tytuł może mieć max 65 znaków' })
        window.scrollTo(0, 0)
        setSelectedTitle(e.target.value.slice(0, 65))
      }
    }
  };

const saveYTURL = (e) => {
  const inputValue = e.target.value;

  // Funkcja pomocnicza do konwersji linku na format embed
  const getEmbedLink = (url) => {
    if (!url) return "";
    // RegEx obsługujący formaty: youtube.com/watch?v=, youtu.be/, youtube.com/embed/
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) 
      ? `https://www.youtube.com/embed/${match[2]}` 
      : url;
  };

  const finalUrl = getEmbedLink(inputValue);

  if (history.location.pathname === '/EdycjaOgloszenia') {
    if (inputValue.length < 150) {
      setAwaitOffer({ ...AwaitOffer, YouTubeURL: finalUrl });
    } else {
      setShowPopUpModal(true);
      setModalVersion(13);
      setModalInfo({ title: 'Link może mieć max. 150 znaków' });
      window.scrollTo(0, 0);
      // Zapisujemy przycięty oryginał, jeśli przekroczył limit
      setAwaitOffer({ ...AwaitOffer, YouTubeURL: finalUrl.slice(0, 150) });
    }
  } else if (history.location.pathname === '/DodajNews') {
    if (inputValue.length < 150) {
      setYTUrl(finalUrl);
    } else {
      setShowPopUpModal(true);
      setModalVersion(13);
      setModalInfo({ title: 'Link może mieć max. 150 znaków' });
      window.scrollTo(0, 0);
      setYTUrl(finalUrl.slice(0, 150));
    }
  }
};





  const saveDescription = (e) => {
    if (history.location.pathname === '/EdycjaOgloszenia') {
      if (e.target.value.length < 8001) {
        setAwaitOffer({ ...AwaitOffer, description: e.target.value })
      }
    } else if (history.location.pathname === '/DodajNews') {
      if (e.target.value.length < 8001) {
        setSelectedDescription(e.target.value)
      }
    }
  };


// const saveOffer = async () => {
//   const now = new Date();
//   const datePath = `${now.getFullYear()}/${String(now.getMonth() + 1).padStart(2, '0')}/${String(now.getDate()).padStart(2, '0')}`;

//   try {
//     const data = {
//       addDate: Date.now(),
//       visibility: true,
//       id: LoggedUser.name.replace(/[.' '/,#$[\]]/g, '') + 
//           (now.toLocaleString('pl').slice(0, 19).replace(/[.' '/,:$[\]]/g, '')),
//       companyName: LoggedUser.name,
//       keyName: LoggedUser.keyName,
//       title: SelectedTitle || null,
//       description: SelectedDescription || null,
//       email: LoggedUser.email,
//       listViews: 0,
//       detailsViews: 0,
//       miniLogoUrl: LoggedUser.MiniLogoUrl || null,
//       YouTubeURL: YTUrl || null,
//       ImagesUrls: SelectedImages.length > 0 
//         ? SelectedImages 
//         : (AwaitOffer?.ImagesUrls || (AwaitOffer?.pictures || []).map(url => ({ uploadedUrl: url })) || [])
//     };

//     // 1. Zapis do bazy
//     await set(AddOfferRef(db, `offers/${data.id}`), data);

//     if (SelectedImages.length > 0) {
//                 await uploadImages( AwaitOffer.id ,SelectedImages, setSelectedImages, setImagesLoading, setUploadProgress)
//                 // zapis fotek then zapis całej oferty z URL fotek
//                 // ale tylko gdy są selected Images czyli była edycja , pomiń aktywacje oferty
//               }

//     // 2. Sukces - wyświetlamy modal i resetujemy stany
//     const isEdit = history.location.pathname === '/EdycjaOgloszenia'; // Sprawdzamy ścieżkę bezpośrednio
    
//     setModalInfo(isEdit 
//       ? { title: 'Zmiany zostały zapisane' } 
//       : { title: 'Newsy dodany, odśwież stronę' }
//     );
    
//     setModalVersion(12);
//     setShowPopUpModal(true);

//     // 3. Czyszczenie pól formularza
//     setSelectedTitle('');
//     setSelectedDescription('');
//     setYTUrl('')
//     setAwaitOffer('');
//     setSelectedImages([]);
    
//     // Opcjonalne przewinięcie na górę, by użytkownik widział modal
//     window.scrollTo(0, 0);

//   } catch (error) {
//     console.error("Błąd podczas zapisu oferty:", error);

//     // Logowanie błędu do bazy
//     try {
//       await set(AddOfferRef(db, `errors/${datePath}/saveOffer/${LoggedUser.name}`), {
//         message: error.message,
//         timestamp: Date.now()
//       });
//     } catch (e) { console.log("Nie udało się zalogować błędu."); }

//         setShowPopUpModal(true)
//         setModalVersion(12)
//         setModalInfo({title:'Ups coś poszło nie tak... sprawdzamy co się stało daj nam chwilę'})
//         set(AddOfferRef(db, `errors/${year}/${month}/${day}/saveDataToCloud`), error.message)
//   }
// };

const saveOffer = async () => {
  const now = new Date();
  const datePath = `${now.getFullYear()}/${String(now.getMonth() + 1).padStart(2, '0')}/${String(now.getDate()).padStart(2, '0')}`;

  // 1. USTALAMY ID OFERTY (potrzebne do folderu zdjęć)
  // Jeśli edytujemy - bierzemy z AwaitOffer, jeśli nowa - generujemy teraz
  const offerId = AwaitOffer.id || (
    LoggedUser.name.replace(/[.' '/,#$[\]]/g, '') + 
    (now.toLocaleString('pl').slice(0, 19).replace(/[.' '/,:$[\]]/g, ''))
  );

  try {
    setShowLoadingAnim(true);

    let finalImagesUrls = [];

    // 2. NAJPIERW UPLOAD ZDJĘĆ (Jeśli są wybrane)
    if (SelectedImages.length > 0) {
      // Czekamy na zakończenie uploadu i odbieramy tablicę z linkami https://...
      const uploadedImages = await uploadImages(
        offerId, 
        SelectedImages, 
        setSelectedImages, 
        setImagesLoading, 
        setUploadProgress
      );
      
      // Mapujemy tylko te dane, które chcemy trzymać w bazie (uploadedUrl)
      finalImagesUrls = uploadedImages.map(img => ({
        uploadedUrl: img.uploadedUrl || img.url
      }));
    } else {
      // Jeśli brak nowych zdjęć, bierzemy stare z edytowanej oferty
      finalImagesUrls = AwaitOffer?.ImagesUrls || [];
    }

    // 3. PRZYGOTOWANIE OBIEKTU DATA (Z PRAWIDŁOWYMI URLAMI)
    const data = {
      addDate: AwaitOffer.addDate || Date.now(), // Zachowaj datę jeśli edycja
      visibility: true,
      id: offerId,
      companyName: LoggedUser.name,
      keyName: LoggedUser.keyName,
      title: SelectedTitle || AwaitOffer.title || null,
      description: SelectedDescription || AwaitOffer.description || null,
      email: LoggedUser.email,
      listViews: AwaitOffer.listViews || 0,
      detailsViews: AwaitOffer.detailsViews || 0,
      miniLogoUrl: LoggedUser.MiniLogoUrl || null,
      YouTubeURL: YTUrl || AwaitOffer.YouTubeURL || null,
      ImagesUrls: finalImagesUrls // <--- Tu trafiają linki https z Firebase
    };

    // 4. ZAPIS CAŁOŚCI DO BAZY (Tylko jeden zapis)
    await set(AddOfferRef(db, `offers/${offerId}`), data);

    // 5. OBSŁUGA SUKCESU
    const isEdit = history.location.pathname === '/EdycjaOgloszenia';
    setModalInfo(isEdit 
      ? { title: 'Zmiany zostały zapisane' } 
      : { title: 'News dodany pomyślnie!' }
    );
    
    setModalVersion(12);
    setShowPopUpModal(true);

    // Czyszczenie
    setSelectedTitle('');
    setSelectedDescription('');
    setYTUrl('');
    setAwaitOffer('');
    setSelectedImages([]);
    window.scrollTo(0, 0);

  } catch (error) {
    console.error("Błąd podczas zapisu:", error);
    setShowPopUpModal(true);
    setModalVersion(12);
    setModalInfo({title:'Błąd zapisu danych'});
    
    // Log błędu
    set(AddOfferRef(db, `errors/${year}/${month}/${day}/saveOffer/${LoggedUser.name}`), error.message);
  } finally {
    setShowLoadingAnim(false);
  }
};

  return (
    <div id='EditFieldsMainDiv'>
      <div id='AddOfferEditFields'>

        
                  <h3 className='InputHeaders'>Tytuł: </h3>
                    <input id='TitleInput' className='OfferDetailsInputs' placeholder='Tytuł' onChange={saveTitle} value={SelectedTitle || ''}></input>
                      {SelectedTitle && SelectedTitle.length ? showTitleInfo() : ''}


                  <h3 className='InputHeaders'>Link do You Tube: </h3>
                    <input id='TitleInput' className='OfferDetailsInputs' placeholder='URL' onChange={saveYTURL} value={YTUrl || ''}></input>
                

        { ImagesLoading ? <FloatingLoading/> : null }
         {history.location.pathname === '/EdycjaOgloszenia' ? <h2 className='EditOfferHeader'>Edytuj dane oferty</h2> : ''}
          {AwaitOffer.id ? <p className='InputHeaders'>ID: {AwaitOffer.id}</p> : null}      
          <h3 className='SectionHeaders'>Zdjęcia</h3> 
            <ImagesPreviewer OfferID={AwaitOffer.id}/>

   

        <h3 className='InputHeaders'>Treść: </h3>
          <textarea id='DescriptionInput' className='OfferDetailsInputs' type='text' placeholder='Opis ...' onChange={saveDescription} value={SelectedDescription || ''}></textarea>

        <div id='NaviBtns'>
          <button onClick={saveOffer}>Zapisz</button>
        </div>
      </div>
    </div>
  )
};


export default ShowEditFields;